import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { verbalTheme } from "./themes/verbal.theme";

export const drawerWidth = 220;

const styles = makeStyles((theme) =>
    createStyles({
        root: {
            display: "flex",
            minHeight: "100vh",
        },
        drawer: {
            [verbalTheme.breakpoints.up("sm")]: {
                flexShrink: 0,
                zIndex: 1,
            },
        },
        app: {
            flex: 1,
            display: "flex",
            flexDirection: "row",
        },
        main: {
            flex: 1,
            background: verbalTheme.palette.background.default,
            minHeight: "100vh",
        },
        demoBar: {
            zIndex: theme.zIndex.drawer + 1,
            backgroundColor: verbalTheme.palette.primary.main,
        },
        toolbar: theme.mixins.toolbar,
    }),
);

export const useBaseLayoutStyle = styles;
